













// vue
import {Vue, Component} from 'vue-property-decorator';

// 组件
import AdviseStyleOne from './AdviseStyleOne.vue';
import LayoutOne from '@/components/layouts/LayoutOne.vue';
import {Toast} from 'vant';

// http
import http from '@/utils/http';
import {addMessageAPI, messageBackgroundAPI} from '@/api/index';

// 工具
import {getLocalStorage} from '@/utils/local-storage';

@Component({
  components: {
    styleOne: AdviseStyleOne,
    layoutOne: LayoutOne,
  },
})
export default class App extends Vue {
  public layoutStyle: string = 'layoutOne';
  public mainStyle: string = 'styleOne';
  public bgImg: string = '';

  public mounted() {
    this.getMessageBackgroundAPI();
  }

  // 提交留言信息
  public updateAdviseInfo(options: any) {
    return new Promise((resolve, reject) => {
      const {requestInit} = addMessageAPI;
      const {name, tel, content} = options;
      const {wxUserInfo} = getLocalStorage();
      const body = {
        content,
        companyKey: '',
        openid: '',
        userName: name,
        userPhone: tel,
      };

      if (wxUserInfo) {
        body.companyKey = wxUserInfo.companyKey;
        body.openid = wxUserInfo.openid;
      }


      requestInit.body = JSON.stringify(body);

      http(addMessageAPI).then((data: any) => {
        Toast('留言成功');
        this.$router.back();
      }).catch((reason) => {
        Toast(reason);
      });
    });
  }

  // 查询背景
  public getMessageBackgroundAPI() {
    return new Promise((resolve, reject) => {
      const {requestInit} = messageBackgroundAPI;
      const body = {
      };

      requestInit.body = JSON.stringify(body);

      http(messageBackgroundAPI).then((data: any) => {
        const {backImg} = data;
        this.bgImg = backImg;
      }).catch((reason) => {
        Toast(reason);
      });
    });
  }
}
